export default __webpack_public_path__ + "static/media/add-multi-material.a9f3bf43.svg";